import Vue from 'vue'
import Vuex from 'vuex'

// Core store
import state from './core/state'
import getters from './core/getters'
import mutations from './core/mutations'
import actions from './core/actions'


// Required Modules
// Should not import any non require modules here to reduce bundle size and first byte loading time.
import Theme from '@/store/modules/theme'
import Customer from '@/store/modules/customer'
import Accounting from '@/store/modules/accounting'
import Prosecution from '@/store/modules/prosecution'
import Report from '@/store/modules/report'
import Master from '@/store/modules/master'
import System from '@/store/modules/system'
import User from '@/store/modules/user'
import Notification from '@/store/modules/notification'
import Dashboard from "@/store/modules/dashboard";

Vue.use(Vuex)

// Set Strict mode
const strict = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict,
  // Core
  state,
  getters,
  mutations,
  actions,
  // Modules
  modules: {
    Theme,
    Customer,
    Accounting,
    Prosecution,
    Report,
    Master,
    System,
    User,
    Notification,
    Dashboard
  }
})
